import React from "react";
import Breadcrumbs from "../../Breadcrumbs/Breadcrumbs.js";
import Accordion from "../../Accordion/Accordion.js";
import data from "../../Data/independentAssessment/independentAssessmentData.json";
import useSEO from "../../hooks/useSEO.js";
import seoConfig from "../../hooks/seoConfig.js";

export default function IndependentAssessment() {
  useSEO(seoConfig.independentAssessment);
  return (
    <section className="licenses antiCorruption development">
      <Breadcrumbs />
      <h1 className="contacts__title history__title licenses__title development__title">
        Независимая оценка качества
      </h1>

      <Accordion data={data} />
    </section>
  );
}
